import selectFilter from './selectFilter';

const checkBoxFilter = ({ ModelService, t }) => selectFilter(ModelService.getCheckBoxOptions(t));

export default checkBoxFilter;



// WEBPACK FOOTER //
// ./src/components/cms/gridComponents/checkBoxFilter.js